

export default function   getViewName(){
    var url = window.location.hash
    url = url.replace("#", "");
    url = url.split("/");
    return url[0];
  }
